import {
  type DefinitionNode,
  type DocumentNode,
  type FieldNode,
  type FragmentDefinitionNode,
  Kind,
} from 'graphql';
import {extractFragmentNamesFromSelectionSet} from 'src/internal/revamp/graphql/documentUtils/field';

export function getFragmentDefinitions(
  ast: DocumentNode,
): FragmentDefinitionNode[] {
  return ast.definitions.filter(
    (def: DefinitionNode): def is FragmentDefinitionNode =>
      def.kind === Kind.FRAGMENT_DEFINITION,
  );
}

export function collectAllReferencedFragments(
  fields: ReadonlyArray<FieldNode>,
  fragmentsByName: ReadonlyMap<string, FragmentDefinitionNode>,
): FragmentDefinitionNode[] {
  const collectedNames = new Set<string>();

  for (const field of fields) {
    if (field.selectionSet) {
      for (const name of extractFragmentNamesFromSelectionSet(
        field.selectionSet,
      )) {
        collectedNames.add(name);
      }
    }
  }

  const queue = Array.from(collectedNames);

  for (let index = 0; index < queue.length; index++) {
    const fragmentName = queue[index]!;
    const fragmentDefinition = fragmentsByName.get(fragmentName);
    if (typeof fragmentDefinition !== 'undefined') {
      for (const nestedFragmentName of extractFragmentNamesFromSelectionSet(
        fragmentDefinition.selectionSet,
      )) {
        if (!collectedNames.has(nestedFragmentName)) {
          collectedNames.add(nestedFragmentName);
          queue.push(nestedFragmentName);
        }
      }
    }
  }

  return Array.from(collectedNames)
    .map((name) => fragmentsByName.get(name))
    .filter(
      (fragment): fragment is FragmentDefinitionNode =>
        typeof fragment !== 'undefined',
    );
}
